import React from 'react'

const KeyTakeaways = ({jdLevelAnalytics, userAnalytics}) => {
  return (
    <div className='mt-8 bg-white rounded-xl border border-[#E4E7EC] px-9 py-6 shadow-[0_5px_10px_rgba(0,0,0,0.08)]'>
        <h1 className='text-[#101828] font-semibold text-lg'>Key Takeaways:- </h1>
        <div className='text-center text-[#475467] text-[.95rem] my-1'>
            No data found.
        </div>
    </div>
  )
}

export default KeyTakeaways